// extracted by mini-css-extract-plugin
module.exports =  {"pendingInviteNotice":"niyT9hm6","card":"ddJFPiXD","error":"qj92gKId","subheading":"rBTn2AIT"};